export default __webpack_public_path__ + "static/media/Doxxed Team 4.c9b76be6.jpg";